import { PUBLIC_UI, PUBLIC_LANGUAGES } from "../../shared/public-content.js";
import {
  LEGAL_DOCS,
  LEGAL_UI,
  LEGAL_UPDATED,
  legalPage,
} from "../../shared/legal-content.js";
import { languages } from "../core/i18n.js";
import { dayxMark } from "./brand.js";
import { icon } from "./icons.js";

const escape = (value) =>
  String(value).replace(
    /[&<>"']/g,
    (ch) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        ch
      ],
  );

const updatedLabel = (language) => {
  const [year, month, day] = LEGAL_UPDATED.split("-").map(Number);
  // Some runtimes lack Uzbek month names, so Uzbek is formatted by hand.
  if (language === "uz")
    return `${day}-${["yanvar", "fevral", "mart", "aprel", "may", "iyun", "iyul", "avgust", "sentabr", "oktabr", "noyabr", "dekabr"][month - 1]} ${year}`;
  return new Date(year, month - 1, day).toLocaleDateString(
    { uz: "uz-Latn-UZ", en: "en-US", ru: "ru-RU" }[language],
    { day: "numeric", month: "long", year: "numeric" },
  );
};

// Footer links shared by the landing page, guides and legal pages.
export const legalLinks = (language) =>
  `<a href="/${language}/privacy">${LEGAL_UI[language].privacy}</a><a href="/${language}/terms">${LEGAL_UI[language].terms}</a>`;

export function legalHTML(path) {
  const page = legalPage(path);
  if (!page) throw new Error("Unknown legal page");
  const { language, id, copy } = page;
  const ui = PUBLIC_UI[language],
    legal = LEGAL_UI[language];
  const languageButton = `<div class="language-control"><button type="button" class="language-trigger" data-language-trigger aria-label="${ui.language}: ${languages[language]}" aria-haspopup="menu" aria-expanded="false">${icon("globe")}<span data-language-label>${languages[language]}</span><span class="language-chevron">${icon("chevron")}</span></button></div>`;
  return `<a class="skip-link" href="#legalContent">${copy.heading}</a>
    <header class="dayx-landing-nav"><a class="wordmark" href="/" aria-label="DayX — ${ui.home}">${dayxMark}</a><nav aria-label="${legal.legal}">${Object.keys(
      LEGAL_DOCS,
    )
      .map(
        (doc) =>
          `<a href="/${language}/${doc}" ${doc === id ? 'aria-current="page"' : ""}>${legal[doc]}</a>`,
      )
      .join(
        "",
      )}</nav><div class="landing-account-links">${languageButton}<a class="landing-login" href="/login">${ui.login}</a><a class="landing-signup" href="/signup">${ui.signup} ${icon("arrow")}</a></div></header>
    <main id="legalContent" class="legal-page">
      <nav class="guide-breadcrumb" aria-label="${ui.home}"><a href="/">DayX</a><span aria-hidden="true">/</span><span>${legal[id]}</span></nav>
      <h1>${escape(copy.heading)}</h1>
      <p class="legal-updated">${legal.updated}: <time datetime="${LEGAL_UPDATED}">${updatedLabel(language)}</time></p>
      <p class="legal-intro">${escape(copy.intro)}</p>
      ${copy.sections
        .map(
          ([heading, items], index) =>
            `<section><h2><span>${String(index + 1).padStart(2, "0")}</span>${escape(heading)}</h2>${items.length > 1 ? `<ul>${items.map((text) => `<li>${escape(text)}</li>`).join("")}</ul>` : `<p>${escape(items[0])}</p>`}</section>`,
        )
        .join("")}
      <div class="legal-languages">${PUBLIC_LANGUAGES.map((lang) => `<a lang="${lang}" hreflang="${lang}" href="/${lang}/${id}" ${language === lang ? 'aria-current="page"' : ""}>${languages[lang]}</a>`).join("")}</div>
    </main><footer class="dayx-footer"><a class="wordmark" href="/">${dayxMark}</a><span>© ${new Date().getFullYear()} DayX. ${ui.rights}</span><div><a href="/#guides">${ui.guides}</a>${legalLinks(language)}</div></footer>`;
}
